import isHistoryEmpty from './is-history-empty';

export default {
  isHistoryEmpty,
};
